import {
  MOON_400,
  MOON_500,
  MOON_600,
  MOON_650,
  THEME,
} from '@wandb/weave/common/css/globals.styles';
import {Link} from 'react-router-dom';
import styled from 'styled-components';

export const PopoverContainer = styled.div`
  font-family: 'Source Sans Pro';
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 10px;
  margin-right: 16px;
  width: 952px;
  background: ${THEME.bgSurface};
  box-shadow: ${THEME.shadowMd};
  border-radius: 4px;
  border: 1px solid light-dark(#dfe0e2, var(--wb-border));
  position: relative;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 10px;
  height: 32px;
`;

export const HeaderTitle = styled.h3`
  height: 32px;
  font-weight: 600;
  font-size: 18px;
  line-height: 32px;
  color: ${THEME.textPrimary};
  margin: 0;
`;

export const TableContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid ${THEME.border};
  border-radius: 4px;
  width: 100%;
`;

export const TableContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: ${THEME.bgSurface};
`;

export const TableRow = styled.div<{isExpanded?: boolean}>`
  display: grid;
  grid-template-columns: 92px 200px 200px 200px 125px 103px;
  align-items: center;
  height: 40px;
  width: 100%;
  background: ${THEME.bgSurface};

  &:hover {
    background: light-dark(
      color-mix(in srgb, var(--oblivion) 3%, transparent),
      color-mix(in srgb, var(--white) 8%, transparent)
    );
  }
`;

export const TableHeaderRow = styled.div`
  display: grid;
  grid-template-columns: 92px 200px 200px 200px 125px 103px;
  align-items: center;
  height: 40px;
  width: 100%;
  background: light-dark(
    color-mix(in srgb, var(--oblivion) 3%, transparent),
    color-mix(in srgb, var(--white) 8%, transparent)
  );
  border-bottom: 1px solid ${THEME.border};
`;

export const TableHeaderCell = styled.div<{padding?: string}>`
  display: flex;
  align-items: center;
  padding: ${props => props.padding || '8px'};
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: light-dark(${MOON_650}, ${THEME.textSecondary});
  text-transform: uppercase;
  letter-spacing: 0px;
  height: 40px;
  gap: 8px;
`;

export const TimeColumn = styled.div`
  display: block;
  align-items: center;
  padding: 8px 8px 8px 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 15px;
  line-height: 140%;
  color: light-dark(${MOON_500}, ${THEME.textTertiary});
  height: 40px;
  gap: 8px;
`;

export const RunColumn = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 140%;
  color: light-dark(${MOON_500}, ${THEME.textTertiary});
  min-width: 0;
  overflow: hidden;
  gap: 8px;
`;

export const QueueColumn = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 140%;
  color: light-dark(${MOON_600}, ${THEME.textSecondary});
  min-width: 0;
  overflow: hidden;
  gap: 2px;
`;

export const ProjectColumn = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 140%;
  color: light-dark(${MOON_600}, ${THEME.textSecondary});
  min-width: 0;
  overflow: hidden;
  gap: 2px;
`;

export const RunLink = styled(Link)`
  color: ${THEME.textLink};
  text-decoration: none;
  font-weight: 600;

  &:hover {
    color: ${THEME.textLinkHover};
  }
`;

export const ClickableText = styled.span`
  cursor: pointer;
  color: inherit;
  font-weight: inherit;

  &:hover {
    color: light-dark(${MOON_400}, ${THEME.textTertiary});
  }
`;

export const StatusColumn = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 8px 16px 8px 8px;
  height: 40px;
  gap: 8px;
`;

export const LeaderboardColumn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  height: 40px;
  gap: 8px;
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px;
  height: 40px;
  background: ${THEME.bgSurface};
  border-top: 1px solid ${THEME.border};
  gap: 16px;
  width: 100%;
`;

export const PaginationText = styled.span`
  font-family: 'Source Sans Pro';
  font-size: 16px;
  line-height: 20px;
  color: light-dark(${MOON_650}, ${THEME.textSecondary});
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 8px;
`;

export const LoadingContainer = styled.div`
  padding: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  width: 100%;
`;

export const EmptyStateContainer = styled.div`
  padding: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  width: 100%;
  color: light-dark(${MOON_500}, ${THEME.textTertiary});
`;
